export default __webpack_public_path__ + "static/media/project1-DJI_0756.a5c21e02.jpg";